import { useState, useEffect } from 'react';
import { getDecodedToken, isAuthenticated as checkAuth } from '../utils/auth';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = () => {
      const isAuth = checkAuth();
      setIsAuthenticated(isAuth);
      
      if (isAuth) {
        const decodedToken = getDecodedToken();
        setUser(decodedToken);
      } else {
        setUser(null);
      }
      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  return {
    user,
    isAuthenticated,
    loading
  };
};

export default useAuth; 